import {ISerializable} from "../entities/ISerializable";

export class ServerError implements ISerializable{
    public message:string;

    constructor(message: string = "") {
        this.message = message;
    }

    public Deserialize(data: {}): void {
        this.message = data['message'];
    }

    public Serialize(): {} {
        return {
            message: this.message,
        };
    }

    public Equals(error:ServerError): boolean{
        return this.message == error.message;
    }
}


// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/server/src/typescript-plugin/error/ServerError.ts